<template>
  <div class="CABiosignAture">
    <div class="search">
      <el-input placeholder="搜索员工姓名、账号" v-model="keyword" class="input-with-select" @keyup.enter.native="screenList">
        <el-button slot="append" icon="el-icon-search" @click="screenList"></el-button>
      </el-input>
    </div>
    <div class="cont">
      
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in pageCount" :key="index">
          <div class="list">
            <el-row :gutter="20">
              <el-col :span="8" v-for="(user,index2) in userList[index]" :key="index2">
                <div class="item">
                  <div class="itemCont">
                    <div class="num">{{user.user_name}}</div>
                    <div class="name">{{user.phone_no}}</div>
                    <!-- <div class="name">研发部>软件组</div> -->
                    <div class="itemBtn tc">
                      <el-button @click="openFingDio(index,index2)">指纹({{user.fingerprintNum}})</el-button>
                      <el-button @click="openCartDio(index,index2)" v-if="isType=='tool' || isType=='key'">员工卡({{user.staffcardNum}})</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <!-- <el-button class="syncBtn" @click="syncMenber('all')" v-if="isType == 'wrc'">同步数据</el-button> -->
    <el-button class="backUp" @click="backUp" v-if="isType == 'tool'||isType == 'key'">返回</el-button>
    <el-button class="backUp" @click="backUp" v-if="isType == 'wrc'">退出登录</el-button>

    <!--指纹数据 star-->
    <el-dialog title="指纹数据" :visible.sync="fingerprintDio" width="40%" center>
      <el-button class="headBtn" @click="openTipsDio('1')">录入指纹</el-button>
      <el-button class="syncBtnDio" @click="syncMenber(userInfo.userId)">同步数据</el-button>
      <div class="noData tc" v-if="fingerList == ''">暂无数据</div>
      <div class="contDio h450" v-else>
        <div class="item" v-for="(item,index) in fingerList" :key="index">
          <div class="name" v-if="item.alias_name">{{item.alias_name}}</div>
          <div class="name" v-else>未命名</div>
          <!-- <div class="time">{{item.time}}</div> -->
          <div class="operation">
            <el-button class="rename" type="text" @click="openRename(index)">重命名</el-button>
            <!-- <el-button class="del" type="text" @click="delList('del',item.id,'1',item.finger_id)">删除</el-button> -->
          </div>
        </div>
      </div>
    </el-dialog>
    <!--指纹数据 end-->

    <!--员工卡数据 star-->
    <el-dialog title="员工卡数据" :visible.sync="cardDio" width="40%" center>
      <el-button class="headBtn" @click="openTipsDio('2')">录入员工卡</el-button>
      <el-button class="syncBtnDio" @click="syncMenber(userInfo.userId)">同步数据</el-button>
      <div class="noData tc" v-if="cardList == ''">暂无数据</div>
      <div class="contDio h450" v-else>
        <div class="item" v-for="(item,index) in cardList" :key="index">
          <div class="name">员工卡{{index+1}}</div>
          <!-- <div class="time">{{item.data}}</div> -->
          <!-- <div class="time">{{item.time}}</div> -->
          <div class="operation">
            <!-- <el-button class="del" type="text" @click="delList('del',item.id,'3')">删除</el-button> -->
          </div>
        </div>
      </div>
    </el-dialog>
    <!--员工卡数据 end-->

    <el-dialog title="录入提示" :visible.sync="tipsDio" :close-on-click-modal="closeTip" width="40%" center @close="closeTips">
      <div class="contDio">
        <div class="tc" v-if="fingerprintDio == true">
          <div class="iconfont icofingerprint"></div>
          <div class="tips">请录入第{{tipNum}}次指纹</div>
          <div class="tipsCol9">若手指过于干燥导致无法识别,请用账号登入或保持手指滋润</div>
        </div>
        <div class="tc" v-else>
          <div class="iconfont icocard"></div>
          <div class="tips">请在下方刷卡处刷员工卡</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="重命名指纹" :visible.sync="reNameDio" width="40%" center class="reNameDio">
      <div class="contDio">
        <el-input placeholder="请输入指纹名称" v-model="reNameform.name"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reNameDio = false">取 消</el-button>
        <el-button type="primary" @click="submitName">重命名</el-button>
      </span>
    </el-dialog>
    <template v-if="onLine == true">
      <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" ref="mqttws" @getMessage="getMessage"></mqttws>
    </template>
    <currtime :isShowInfo="isType=='key' ? false : true"></currtime>

    <div class="Loading" v-if="isFingLoading">
      <div>
        <img src="../../../../../static/images/a.gif" alt="">
        <div class="mt20">{{isLoadingText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import currtime from '../../../../assets/currTime'
import mqttws from '../../../../assets/mqttws'
// import Swiper from 'swiper';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { adminApi,wareApi } from "../../../../../static/js/api.js"
import { localUserInfo,showLoading,hideLoading,text2Audio,checkOnLine } from '../../../../../static/js/utils/utility.js'
import { checkData } from '../../../../../static/js/utils/util.js'
import * as config from '../../../../../static/js/config.js';
import oneMp3 from '../../../../../static/mp3/one.mp3'
import twoMp3 from '../../../../../static/mp3/two.mp3'
import threeMp3 from '../../../../../static/mp3/three.mp3'
import fourMp3 from '../../../../../static/mp3/four.mp3'
import errorMp3 from '../../../../../static/mp3/error.mp3'
import error2Mp3 from '../../../../../static/mp3/error2.mp3'
import error3Mp3 from '../../../../../static/mp3/error3.mp3'
import enterSuccessMp3 from '../../../../../static/mp3/enterSuccess.mp3'
import againMp3 from '../../../../../static/mp3/again.mp3'
import cardMp3 from '../../../../../static/mp3/card.mp3'
import longtimeMp3 from '../../../../../static/mp3/longtime.mp3'

import qs from 'qs'
import axios from 'axios'

var timeInt;

export default {
  name: 'CABiosignAture',
  data () {
    return {
      isType:'',
      // cabinet_id:'',//设备id
      keyword:'',//搜索关键词
      userList:[],//员工列表
      allList:[],//所有列表

      pageCount:0,//总页数

      fingerprintDio:false,//指纹数据弹窗
      fingerList:[],

      userInfo:{
        // type:'',
        userId:'',
        // index:0,
        // index2:0,
      },

      cardDio:false,
      cardList:[],

      tipsDio:false,//录入提示弹窗
      tipNum:1,

      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets:true,
        },
        observer:true, 
      },

      reNameDio:false,//指纹重命名弹窗
      reNameform:{
        id:'',
        name:'',
      },

      fingerId_del:'',//删除指纹时临时存储的指纹id

      // isMqttShow:false,
      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg:'a5551505160101010000000101d6020000dc',
      isConnect:false,//是否默认订阅

      timeItem:0,//时间定时
      finNum:0,//录入指纹失败5次，请换手指录入
      closeTip:false,//是否可以点击遮罩层关闭提示框

      overtime:30,//超时
      overtimeStatus:'',//超时状态

      onLine:false,//网络状态

      isFingLoading:false,//录入指纹后loading
      isLoadingText:'数据处理中，请等待~',
    }
  },
  //定义这个sweiper对象  
  computed: {
    swiper() {  
      return this.$refs.mySwiper.swiper;  
    }  
  },
  mounted(){
    
  },
  components:{
    mqttws,
    swiper,
    swiperSlide,
    currtime
  },
  created(){
    // this.cabinet_id = config.deviceId
    this.isType = this.$route.query.isType
    this.getUserList()
    this.onLine = this.$store.state.onLine
  },
  methods:{
    //同步数据
    syncMenber(userid){
      var that = this
      var data = {
        'did':config.deviceId,
        'userid':userid
      }
      this.isLoadingText="数据同步中，请等待30秒~"
      this.isFingLoading = true
      axios({
        method: 'post',
        url: 'http://'+config.address2+'/cgi-bin/dlfg.cgi',
        headers: config.commomHeaders,
        data: qs.stringify(data)
      })
      .then(function (res) {
        var res = res.data
        if(res.code == 200){
          if(res.status == '1'){
            that.isFingLoading = false
            that.$message.success('同步成功')
          }else if(res.status == '0'){
            that.isFingLoading = false
            that.$message.error('同步失败')
          }
        }else{
          that.isFingLoading = false
          that.$message.error('同步异常')
        }
      })
      .catch(function (error) {
        that.isFingLoading = false
        that.$message.error('接口异常')
      })
      // var res = await wareApi.syncMenber(qs.stringify(data))
      // if(res.code == 200){
      //   if(res.status == '1'){
      //     that.$message.success('同步成功')
      //     that.isFingLoading = false
      //   }else{
      //     that.$message.success('同步失败')
      //     that.isFingLoading = false
      //   }
      // }else{
      //   that.isFingLoading = false
      // }
    },
    //关闭提示框
    closeTips(){
      var that = this
      clearInterval(timeInt)
      clearTimeout(that.overtimeStatus)
      this.tipNum = 1;
      var msg = 'a5551505160101010000000101d6070000d9'
      var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
      this.$refs.mqttws.send(topic,msg)
      this.tipsDio = false;
    },
    //提交修改命名
    async submitName(){
      var that = this;
      var data2 = {
        'way': 'rename',
        'user_id': that.userInfo.userId,
        'alias_name': that.reNameform.name,
        'id':that.reNameform.id
      }
      var res = await adminApi.updateUser(data2)
      if (res.meta.code == 200) {
        that.$message.success('修改成功')
        that.reNameDio = false
        // that.fingerprintDio = false
        // that.getCharacteristic('1')
        this.getCharacteristic(that.userInfo.userId,'1')
        that.getUserList()
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //打开重命名
    openRename(index){
      this.reNameform.id = this.fingerList[index].id
      this.reNameform.name = this.fingerList[index].alias_name
      this.reNameDio = true
    },
    //更新用户数据
    async updateUser(index,index2){
      var that = this;
      var data2 = {
        'way': 'enter',
        'user_id': that.userInfo.userId,
        'type': type,
        'data': data,
      }
      var res = await adminApi.updateUser(data2)
      if (res.meta.code == 200) {
        that.tipsDio = false
        if(type == 1){
          that.fingerprintDio = false
        }else if(type == 3){
          that.cardDio = false
        }
        that.getUserList()
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //接收mqtt返回信息
    getMessage(data){
      var that = this
      if(data){
        that.overtime=30
        if(that.fingerprintDio == true && that.tipsDio == false){
          var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
          var num = checkData(str)
          var bbc = data.substr(data.length-2)
          var lastTwo = str.substring(str.length-2,str.length)
          var type = str.substring(26,30)
          if(type == 'd603'){
            if( num == bbc && lastTwo == 55){
              that.fingerId_del = '';
            }else{
              var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
              var msg = 'a5551505160101010000000101d6030002'+that.fingerId_del
              var num2 = checkData(msg)
              msg = msg+num2
              that.$refs.mqttws.send(topic,msg)
            }
          }else{
            that.fingerprintStart(data)
          }
          
        }else if(that.fingerprintDio == true && that.tipsDio == true){
          that.entryFingerprint(data)
        }if(that.cardDio == true && that.tipsDio == true){
          that.getCard(data)
        }
      }
    },
    //保存数据
    async saveUserData(data,type,fingId){
      var that = this;
      if(type == '1'){
        var data2 = {
          'way': 'enter',
          'user_id': that.userInfo.userId,
          'type': type,
          'data': data,
          'finger_id': fingId,
          'device_no_id': config.deviceId
        }
      }else if(type == '3'){
        var data2 = {
          'way': 'enter',
          'user_id': that.userInfo.userId,
          'type': type,
          'data': data,
          'device_no_id': config.deviceId
        }
      }
      var res = await adminApi.updateUser(data2)
      if (res.meta.code == 200) {
        that.tipsDio = false
        if(type == 1){
          that.tipNum = 1;
          that.isFingLoading = false
        }
        // if(type == 1){
        //   that.fingerprintDio = false
        // }else if(type == 3){
        //   that.cardDio = false
        // }
        // text2Audio('录入成功')
        var url = enterSuccessMp3
        var audio = new Audio(url);
        audio.src = url;
        audio.play();

        that.$message.success('录入成功！')
        // that.getCharacteristic(type)
        that.getCharacteristic(that.userInfo.userId,type)
        that.getUserList()
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //接收录入卡信息
    getCard(data){
      var that = this
      var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
      var num = checkData(str)
      var bbc = data.substr(data.length-2)
      var type = str.substring(26,30)
      // var character = str.substring(str.length-8,str.length)
      var character = str.substring(34,str.length)
      if(num == bbc && type == 'df0b'){
        clearTimeout(that.overtimeStatus)
        that.saveUserData(character,'3')
      }else{
        // text2Audio('请重新录入')
        that.$message('请重新录入！')
        var url = againMp3
        var audio = new Audio(url);
        audio.src = url;
        audio.play();
      }
    },
    //录入指纹
    entryFingerprint(data){
      var that = this
      var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
      var num = checkData(str)
      var bbc = data.substr(data.length-2)
      var lastTwo = str.substring(34,36)
      var fingId = str.substring(36,40)
      var character = str.substring(40,str.length)
      var type = str.substring(26,30)
      var long = str.substring(30,34)
      that.timeItem = 0;
      if(that.tipNum == 1){
        clearInterval(timeInt)
      }
      if(type == 'df09'){
        if(lastTwo == 55 && num == bbc){
          that.finNum=0
          that.tipNum += 1;

          if(that.tipNum>4){
            that.tipNum = 4;
            that.isLoadingText = '数据处理中，请等待~'
            that.isFingLoading = true

            if(long != '0001'){
              // that.tipNum = 1;
              clearTimeout(that.overtimeStatus)
              that.saveUserData(character,'1',fingId)
            }
          }else{
            // text2Audio('请录入第'+that.tipNum+'次指纹')
            if(that.tipNum == 1){
              var url = oneMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }else if(that.tipNum == 2){
              var url = twoMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }else if(that.tipNum == 3){
              var url = threeMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }else if(that.tipNum == 4){
              var url = fourMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }
          }
        }else{
          var len = str.substring(36,str.length)
          if(len.length>2){
            // text2Audio('录入失败，请重新录入')
            var url = errorMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            that.$message.error('录入失败，请重新录入')
            that.tipsDio = false;
            that.tipNum = 1;
          }else{
            that.finNum+=1
            if(that.finNum > 5){
              // text2Audio('录入失败，请更换手指录入')
              var url = error2Mp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              that.$message.error('录入失败，请更换手指录入！')
              that.finNum=0
            }else{
              // text2Audio('录入失败，请重按指纹')
              var url = error3Mp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              that.$message.error('录入失败，请重按指纹！')
            }
          }
        }
      }
    },
    //录入指纹准备完毕
    fingerprintStart(data){
      var that = this
      var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
      var num = checkData(str)
      var bbc = data.substr(data.length-2)
      var lastTwo = str.substring(str.length-2,str.length)
      var type = str.substring(26,30)
      if(type == 'd602'){
        if(lastTwo == 55 && num == bbc){
          var topic2 = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
          that.$refs.mqttws.onConnect(topic2)
          that.tipsDio = true
          // text2Audio('请录入第1次指纹')
          //指纹语音提示
          var url = oneMp3
          var audio = new Audio(url);
          audio.src = url;
          audio.play();

          timeInt = setInterval(function(){
            that.timeItem += 1;//计算超时
          }, 1000);
        }
        else{
          that.openTipsDio('1')
        }
      }else{
        
      }
    },
    //开始录入信息
    openTipsDio(type){
      var that = this
      this.overTime(this.overtime);//计算超时开始

      //录入指纹
      if(type == '1'){
        var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response'
        this.$refs.mqttws.onConnect(topic)
        // console.log('topic',that.topic)
        // console.log('msg',that.msg)
        that.$refs.mqttws.send(that.topic,that.msg)
      }else{
        //录入员工卡
        var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
        this.$refs.mqttws.onConnect(topic)
        that.tipsDio = true
        // text2Audio('请在下方刷卡处刷员工卡')
        var url = cardMp3
        var audio = new Audio(url);
        audio.src = url;
        audio.play();
      }
    },
    //打开指纹弹窗
    openFingDio(index,index2){
      // console.log('openFingDio',this.onLine)
      if(this.onLine == false){
        checkOnLine()
      }else{
        this.userInfo.userId = this.userList[index][index2].user_id
        // this.userInfo.type = '1'
        // this.userInfo.index = index
        // this.userInfo.index2 = index2
        // this.fingerList = this.userList[this.userInfo.index][this.userInfo.index2].data.fingerprint
        // // this.getCharacteristic('1')
        this.getCharacteristic(this.userInfo.userId,'1')
        this.fingerprintDio = true
      }
    },
    //打开员工卡弹窗
    openCartDio(index,index2){
      if(this.onLine == false){
        checkOnLine()
      }else{
        this.userInfo.userId = this.userList[index][index2].user_id
        // this.userInfo.type = '3'
        // this.userInfo.index = index
        // this.userInfo.index2 = index2
        // this.cardList = this.userList[this.userInfo.index][this.userInfo.index2].data.staffcard
        // // this.getCharacteristic('3')
        this.getCharacteristic(this.userInfo.userId,'3')
        this.cardDio = true
      }
    },
    //获取用户详情
    async getCharacteristic(userid,type){
      var that = this;
      var data2 = {
        'user_id': userid,
        'type': type,
        'device_no_id':config.deviceId,
      }
      var res = await adminApi.getCharacteristic(data2)
      if (res.meta.code == 200) {
        if(type == '1'){
          this.fingerList = res.body
        }else{
          that.cardList = res.body
        }
      }
    },
    // getCharacteristic(type){
    //   var that = this;
    //   if(type == '1'){
    //     this.fingerList = this.userList[this.userInfo.index][this.userInfo.index2].data.fingerprint
    //   }else{
    //     this.cardList = this.userList[this.userInfo.index][this.userInfo.index2].data.staffcard
    //   }
    // },
    //获取员工列表
    async getUserList(){
      var that = this
      showLoading();
      // var data = {
      //   'cabinet_id': config.deviceId,
      // };
      // var res = await adminApi.getUserLists(data)
      var data = {
        'wms':'user',
      }
      var res = await wareApi.ylcbdh(qs.stringify(data))
      if(res.body != ''){
        for(var i in res.body){
          res.body[i].fingerprintNum = res.body[i].data.fingerprint.length
          res.body[i].staffcardNum = res.body[i].data.staffcard.length
        }
      }
      that.allList = res.body
      that.screenList()
      hideLoading()
      // if (res.meta.code == 200) {
      //   if(res.body != ''){
      //     for(var i in res.body){
      //       res.body[i].fingerprintNum = res.body[i].data.fingerprint.length
      //       res.body[i].staffcardNum = res.body[i].data.staffcard.length
      //       for(var ii in res.body[i].data.fingerprint){
      //         if(!res.body[i].data.fingerprint[ii].alias_name){
      //           res.body[i].data.fingerprint[ii].alias_name = '未命名'
      //         }
      //       }
      //     }
      //   }
      //   that.allList = res.body
      //   that.screenList()
      //   hideLoading()
      // } else {
      //   hideLoading()
      //   that.$message.error(res.meta.message)
      // }
    },
    //列表筛选
    screenList(){
      var that = this;
      var allList = that.allList
      var limits = 6;//每页显示条数
      var searchList = []
      for(var i in allList){
        if(that.keyword!=''){
          if(allList[i].user_name.indexOf(that.keyword) != -1 || allList[i].user_id.toString().indexOf(that.keyword) != -1){
            searchList.push(allList[i])
          }
        }else{
          searchList = allList
        }
      }
      that.pageCount = Math.ceil(searchList.length/limits)
      // console.log(searchList)
      var arr = []
      for(var i = 0, j = searchList.length; i < j; i += limits){
        arr.push(searchList.slice(i,i+limits))
      }
      that.userList =arr
      // if(that.userInfo.type!=''){
      //   if(that.userInfo.type=='1'){
      //     that.fingerList = that.userList[that.userInfo.index][that.userInfo.index2].data.fingerprint
      //   }else if(that.userInfo.type=='3'){
      //     that.cardList = that.userList[that.userInfo.index][that.userInfo.index2].data.staffcard
      //   }
      // }
    },
    //返回
    backUp(){
      var that = this
      clearTimeout(this.overtimeStatus)
      // this.$refs.mqttws.disconnect()
      if(that.isType == 'tool'){
        that.$router.push({
          path:'/toolCabinet/CAdmin',
        })
      }else if(that.isType == 'wrc'){
        localUserInfo.removeItem()
        that.$router.push({
          path:'/unmanned/wrcIndex',
        })
      }else if(that.isType == 'key'){
        that.$router.push({
          path:'/keyCabinet/keyBorrow',
        })
      }
    },
    //删除
     delList(way,id,type,finger_id){
      var that = this;
      this.$confirm('确定删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async function() {
        var data2 = {
          'way': way,
          'user_id': that.userInfo.userId,
          'id':id
        }
        var res = await adminApi.updateUser(data2)
        if (res.meta.code == 200) {
          that.$message.success('删除成功')
          // that.getCharacteristic(type)
          that.getCharacteristic(that.userInfo.userId,type)
          that.getUserList()
          //发送删除指纹命令
          if(type == '1'){
            that.fingerId_del = finger_id
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d6030002'+finger_id
            var num2 = checkData(msg)
            msg = msg+num2
            that.$refs.mqttws.send(topic,msg)
            var topic2 = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response'
            this.$refs.mqttws.onConnect(topic2)
          }

          // if(type == 1){
          //   that.fingerprintDio = false
          // }else{
          //   that.cardDio = false
          // }
        }
      }).catch(function(){
        
      });
    },
    //超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        // clearTimeout(that.overtimeStatus)
        that.closeTips()
        // that.$router.go(0)
      } else {
        this.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    },
  },
  watch :{
    timeItem(){
      //20s超时重新录指纹
      if(this.timeItem>=20){
        this.$message.error('您长时间未录入指纹，请重新录入！')
        // text2Audio('您长时间未录入指纹，请重新录入！')
        var url = longtimeMp3
        var audio = new Audio(url);
        audio.src = url;
        audio.play();

        clearInterval(timeInt)
        var msg = 'a5551505160101010000000101d6070000d9'
        var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
        this.$refs.mqttws.send(topic,msg)

        this.timeItem = 0
        this.tipsDio = false;
        this.tipNum = 1;
      }
    },
    "$store.state.onLine":function(newVal){
      // console.log('abonline',newVal)
      this.onLine = newVal
    }
  },
}
</script>

<style lang="less">
.CABiosignAture{
  padding: 0.55rem 0 0.35rem;
  touch-action: none;
  height: 100vh;
  // background: url('../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  
  .Loading{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .5);
    z-index: 8888;
    text-align: center;
    font-size: 0.3rem;
    img{
      width: 1rem;
      height: 1rem;
    }

  }
  box-sizing: border-box;
  .h450{
    height: 4.5rem;
    overflow-y: auto;
  }
  .reNameDio{
    .el-input__inner{
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.3rem;
    }

  }
  .el-dialog .headBtn{
    position: absolute;
    left: 0.29rem;
    top: 0.29rem;
    font-size: 0.32rem;
    border-radius: 0.1rem;
    height: auto;
    padding: 0.22rem 0.24rem;
    color: #2d83f3;
    border:0.01rem solid #2d83f3;
  }
  .el-dialog .syncBtnDio{
    height: 0.54rem;
    padding: 0 0.3rem;
    font-size: 0.26rem;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.54rem;
    background: linear-gradient(#4aaafe, #0769be);
  }
  .contDio{
    .iconfont{
      font-size: 1.67rem;
      color: #409EFF;
    }
    .tips{
      font-size: 0.4rem;
      margin: 0.3rem 0;
    }
    .tipsCol9{
      color: #999;
      font-size: 0.26rem;
    }
    .item{
      font-size: 0.3rem;
      color: #777;
      border-bottom: 0.01rem solid #bfbfbf;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.88rem;
      .el-button{
        font-size: 0.3rem;
        padding: 0;
        border-radius: 0;
      }
      .rename{
        color: #2d83f3;
        margin-right: 0.3rem;
      }
      .del{
        color: #f71616;
      }
    }
  }
  .backUp{
    position: absolute;
    right: 0.94rem;
    bottom: 0.47rem;
    height: 0.94rem;
    // width: 2.54rem;
    padding: 0 0.6rem;
    font-size: 0.4rem;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.94rem;
    background: linear-gradient(#4aaafe, #0769be);
  }
  .syncBtn{
    position: absolute;
    left: 0.94rem;
    bottom: 0.47rem;
    height: 0.94rem;
    // width: 2.54rem;
    padding: 0 0.6rem;
    font-size: 0.4rem;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.94rem;
    background: linear-gradient(#4aaafe, #0769be);
  }
  .swiper-container {
    height: 7.08rem;
    .list{
      height: 7.08rem;
      // margin: 0 2.16rem;
      margin: 0;
      // background: linear-gradient(#3f84b2, #42596e);
      padding: 0.74rem 1.18rem;
      // box-shadow: 0 0.08rem 0.07rem 0.03rem rgba(68, 76, 128, 0.26);
      .el-col-8{
        padding-left: 0.26rem;
        padding-right: 0.26rem;
      }
      .item{
        background: #f0f0f0;
        border-radius: 0.1rem;
        margin-bottom: 0.27rem;
        padding: 0.28rem 0.42rem;
        font-size: 0.42rem;
        // width: 3.74rem;
        width: 5.18rem;
        height: 2.49rem;
        box-sizing: border-box;
        position: relative;
        .num{
          font-size: 0.4rem;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .name{
          margin-top: 0.15rem;
          font-size: 0.36rem;
          color: #666;
        }
        .itemBtn{
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 0.22rem;
        }
        .el-button{
          margin-top: 0.2rem;
          height: 0.65rem;
          width: 2rem;
          padding: 0;
          font-size: 0.26rem;
          font-weight: bold;
          color: #2d83f3;
          border: 0.01rem solid #2d83f3;
          border-radius: 0.1rem;
          line-height:0.65rem;
          background:none;
        }
      }
    }
  }
  .search{
    width: 40%;
    margin: 0 1.18rem 0.5rem;
    .el-input-group{
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 0.1rem;
      .el-input__inner{
        display: inline-flex;
        height: 0.85rem;
        line-height: 0.85rem;
        background: #fff;
        color: #666;
        border: none;
        border-radius: 0;
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
        padding: 0 0.3rem;
        box-sizing: border-box;
      }
      .el-input-group__append, .el-input-group__prepend{
        width: auto;
        display: inline-flex;
        background: #fff;
        color: #525252;
        height: 0.85rem;
        border: none;
        border-radius: 0;
        font-size: 0.4rem;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
      }
    }
  }
  .noData{
    font-size: 0.3rem;
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CAdmin/CABiosignAture.vue